"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.companySubMenu = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
const companySubMenu = exports.companySubMenu = [{
  path: '/companies/list',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/master/company/list.vue'))),
  name: 'Companies',
  meta: {
    title: 'companyManagement.companies.title',
    noCache: true,
    icon: 'building',
    roles: ['System Admin']
  }
}, {
  path: '/companies/add',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/master/company/manage.vue'))),
  name: 'AddCompany',
  props: {
    isEdit: false
  },
  meta: {
    title: 'companyManagement.companies.manage',
    noCache: true,
    activeMenu: '/companies/list',
    hidden: true
  }
}, {
  path: '/companies/edit/:id(\\d+)',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/master/company/manage.vue'))),
  name: 'EditCompany',
  props: {
    isEdit: true
  },
  meta: {
    title: 'companyManagement.companies.manage',
    noCache: true,
    activeMenu: '/companies/list',
    hidden: true
  }
}];